import { IonContent, IonHeader, IonPage, IonToolbar, IonButton, IonIcon, IonGrid, IonRow, IonCol } from '@ionic/react';
import React, { useState } from 'react';
//import ExploreContainer from '../components/ExploreContainer';
import ChatContainer from '../components/ChatContainer';
import ExitContainer from '../components/ExitContainer';

let initted = false;

const Chats: React.FC = () => {

  const [wideScreenMode, setWideScreenMode] = useState(false);
  
  if (!initted) {
    initted = true;

    if (window.innerWidth > 800) {
      setWideScreenMode(true);
    }
  }

  return (
    <IonPage>
      {/* <IonHeader className="myheader">
        <IonToolbar>
            <IonButton href="/Profile">
              <IonIcon className="topicon" src="assets/icon/profile.svg" />
            </IonButton>
            <IonButton href="/Events">
            <IonIcon className="topicon" src="assets/icon/events.svg" />
            </IonButton>
            <IonButton href="/Swipe">
              <IonIcon slot="icon-only" src="assets/icon/swipe.svg" />
            </IonButton>
            <IonButton href="/Chats">
              <IonIcon slot="icon-only" src="assets/icon/chat-on.svg" />
            </IonButton>
        </IonToolbar>
    </IonHeader> */}

    <IonContent>
    {wideScreenMode? (
        <IonGrid>
          <IonRow>
          <IonCol className="sideCol" size="1"></IonCol>
            <IonCol className="mainCol" size="10">
              <div className="mainDiv">
                <ChatContainer/>
                <ExitContainer></ExitContainer>
              </div>
            </IonCol>
             <IonCol className="sideCol" size="1"></IonCol>
          </IonRow>
        </IonGrid>
                ):(
                  <div>
                  <ChatContainer/>
                  <ExitContainer></ExitContainer>
                </div>
                )}
        
      </IonContent>
    </IonPage>
  );
};

export default Chats;
